// extracted by mini-css-extract-plugin
export default {"icon":"icon__ExternalLink__V298G","link":"link__ExternalLink__V298G"};